import { render, staticRenderFns } from "./ques-gender.vue?vue&type=template&id=f4321414&scoped=true&"
import script from "./ques-gender.vue?vue&type=script&lang=js&"
export * from "./ques-gender.vue?vue&type=script&lang=js&"
import style0 from "./ques-gender.vue?vue&type=style&index=0&id=f4321414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4321414",
  null
  
)

export default component.exports